import type { BrandKit } from '@doer/frontend-components/creativity-editor';

const COLORS: string[] = ['#616365', '#FE7606', '#FD7708'];

export const HIPOTECARIO_BRAND_KIT: BrandKit = {
  colors: COLORS
};
